import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap mt-10" }
const _hoisted_2 = {
  class: "flex-item",
  justify: "start"
}
const _hoisted_3 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_4 = {
  class: "flex-item",
  justify: "start"
}
const _hoisted_5 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1)
const _hoisted_7 = { class: "flex-item" }
const _hoisted_8 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1)
const _hoisted_10 = { class: "flex-item" }
const _hoisted_11 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_12 = { class: "flex-item" }
const _hoisted_13 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_14 = {
  class: "flex-item",
  justify: "start"
}
const _hoisted_15 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1)

import { computed, onBeforeUnmount, onMounted, ref } from "vue"

import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"
import {
  ApplicantTime,
  Department,
  DoctorProfile,
  HospitalDoctor,
} from "@/types"
import { hospitalActions } from "@/stores/hospital-actions"
import PhotoUpload from "@/components/Static/PhotoUpload/PhotoUpload.vue"
import { doctorTitle } from "@/types/spec"
import { doctorActions } from "@/stores/doctor-actions"
import { useToast } from "vue-toast-notification"


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalDoctorProfile',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const hospitalAction = hospitalActions()
const route = useRoute()
const requestResponse = ref()
const doctor = ref<HospitalDoctor>()
const loading = ref(true)
const id = ref()
const title = ref<string | undefined>(undefined)
const firstName = ref<string | undefined>(undefined)
const lastName = ref<string | undefined>(undefined)
const email = ref<string | undefined>(undefined)
const phoneNumber = ref<string | undefined>(undefined)
const photo = ref<string | undefined>(undefined)
const departments = ref<Department[]>([])
const chosenDepartment = ref<string | null>(null)
const locale = ref(localStorage.getItem("locale") || "de")
const smallWindow = ref(window.innerWidth < 1000)
const lectureFreeSearch = ref(false)
const activeSearch = ref(false)
const manualTime = ref<any[][]>([])
const applicants = ref<ApplicantTime[]>([])
const isSaving = ref(false)
const props = __props
onMounted(async () => {
  id.value = route.params.id
  await getDoctorProfile()
  await getDepartments()
  window.addEventListener("resize", updateWindowSize)
  window.addEventListener("locale-changed", updateLocale)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
  window.removeEventListener("locale-changed", updateLocale)
})

const getDoctorProfile = async () => {
  loading.value = true

  title.value = props.doctor?.title ?? "-"
  firstName.value = props.doctor?.firstName ?? undefined
  lastName.value = props.doctor?.lastName ?? undefined
  email.value = props.doctor?.email ?? undefined
  photo.value = props.doctor?.photo
  phoneNumber.value = props.doctor?.privatePhone
  chosenDepartment.value = props.doctor?.department ?? null

  loading.value = false
}

const notEmptyRule = [(v: string) => !!v || t("field-required")]

const getDepartmentName = computed(() => (department: Department): string => {
  return locale.value == "de" ? department.de : department.en
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

const updateLocale = () => {
  locale.value = localStorage.getItem("locale") ?? "de"
}
const getDepartmentValue = (department: Department): string => {
  return department.value
}

const getDepartments = async () => {
  const response = await hospitalAction.getDepartments()
  requestResponse.value = response
  if (response.success) {
    departments.value = response.result as Department[]
  }
}

const infoCompleted = computed((): boolean => {
  return (
    firstName.value != "" &&
    lastName.value != "" &&
    chosenDepartment.value != null &&
    activeSearch.value &&
    (manualTime.value[manualTime.value.length - 1]?.[0].length == 0 ||
      manualTime.value[manualTime.value.length - 1]?.[0]?.[0] == null ||
      manualTime.value[manualTime.value.length - 1]?.[0]?.[1] == null ||
      manualTime.value[manualTime.value.length - 1]?.[1] < 1)
  )
})

const saveProfile = async (): Promise<void> => {
  isSaving.value = true
  var applicants: ApplicantTime[] = []

  const docAction = doctorActions()
  const $toast = useToast()

  manualTime.value.forEach((val) => {
    const data: ApplicantTime = {
      start: docAction.getDatesInString(val[0][0] as Date),
      end: docAction.getDatesInString(val[0][1] as Date),
      applicants: parseInt(val[1].toString()),
    }
    applicants.push(data)
  })
  const profile = {
    firstName: firstName.value,
    lastName: lastName.value,
    title: title.value,
    photo: photo.value,
    phoneNumber: phoneNumber.value,
    department: chosenDepartment.value,
  }

  const response = await hospitalAction.saveDoctorProfile(id.value, profile)
  requestResponse.value = response
  isSaving.value = false
  if (response.success) {
    $toast.success(t("profile-saved-successfully"), {
      position: "bottom-left",
    })
  } else {
    $toast.error(response.message ?? "", {
      position: "bottom-left",
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, {
      response: requestResponse.value,
      isLoading: loading.value
    }, null, 8, ["response", "isLoading"]),
    _createElementVNode("div", null, [
      (props.doctor && !loading.value)
        ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(PhotoUpload, {
                photo: photo.value,
                isHospital: true,
                onPhotoUploaded: _cache[0] || (_cache[0] = ($event: any) => (photo.value = $event))
              }, null, 8, ["photo"]),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("doctor.title")), 1),
                  _createVNode(_component_v_select, {
                    class: "ml-2",
                    modelValue: title.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('doctor.title'),
                    "prepend-inner-icon": "mdi-pencil",
                    items: _unref(doctorTitle),
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "items"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t("first-name")) + " ", 1),
                    _hoisted_6
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: firstName.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstName).value = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('first-name'),
                    "prepend-inner-icon": "mdi-pencil",
                    variant: "outlined",
                    rules: notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t("last-name")) + " ", 1),
                    _hoisted_9
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: lastName.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastName).value = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('last-name'),
                    "prepend-inner-icon": "mdi-pencil",
                    variant: "outlined",
                    rules: notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("email")), 1),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: email.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event)),
                    density: "compact",
                    readonly: "",
                    placeholder: _ctx.$t('email'),
                    "prepend-inner-icon": "mdi-email-outline",
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("phoneNumber")), 1),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: phoneNumber.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phoneNumber).value = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('phoneNumber'),
                    "prepend-inner-icon": "mdi-cellphone",
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.department")) + " ", 1),
                    _hoisted_16
                  ]),
                  _createVNode(_component_v_autocomplete, {
                    class: "ml-2",
                    modelValue: chosenDepartment.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenDepartment).value = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('hospital.department'),
                    items: departments.value,
                    "item-title": getDepartmentName.value,
                    "item-value": getDepartmentValue,
                    "prepend-inner-icon": "mdi-hospital-building",
                    rules: notEmptyRule,
                    variant: "outlined",
                    "menu-props": { width: '300px' }
                  }, null, 8, ["modelValue", "placeholder", "items", "item-title"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_footer, { style: {"display":"flex","width":"96%","justify-content":"end","background-color":"#f2f2f2"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_btn, {
              class: "mr-10",
              rounded: "lg",
              color: "#3fb984",
              variant: "flat",
              size: "large",
              width: "150",
              loading: isSaving.value,
              disabled: infoCompleted.value,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (saveProfile()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})